import env from 'react-dotenv';


// export const BASE_URL = process.env.REACT_APP_API_URL;
export const BASE_URL = env[process.env.REACT_APP_HOST_TYPE];
